export const recipeStars: { [index: number]: number } = {
  55: 1,
  56: 1,
  57: 1,
  58: 1,
  59: 1,
  60: 1,
  61: 1,
  62: 1,
  63: 1,
  64: 1,
  65: 1,
  66: 1,
  67: 1,
  68: 1,
  69: 1,
  70: 2,
  71: 2,
  72: 2,
  73: 2,
  74: 2,
  75: 2,
  76: 2,
  77: 2,
  78: 2,
  79: 2,
  80: 2,
  81: 2,
  82: 2,
  83: 2,
  84: 2,
  85: 2,
  86: 2,
  87: 2,
  88: 2,
  89: 2,
  90: 3,
  91: 3,
  92: 3,
  93: 3,
  94: 3,
  95: 3,
  96: 3,
  97: 3,
  98: 3,
  99: 3,
  100: 3,
  101: 3,
  102: 3,
  103: 3,
  104: 3,
  105: 3,
  106: 3,
  107: 3,
  108: 3,
  109: 3,
  110: 4,
  111: 4,
  112: 4,
  113: 4,
  114: 4,
  160: 1,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 1,
  166: 1,
  167: 1,
  168: 1,
  169: 1,
  170: 1,
  171: 1,
  172: 1,
  173: 1,
  174: 1,
  175: 1,
  176: 1,
  177: 1,
  178: 1,
  179: 1,
  180: 2,
  181: 2,
  182: 2,
  183: 2,
  184: 2,
  185: 2,
  186: 2,
  187: 2,
  188: 2,
  189: 2,
  190: 2,
  191: 2,
  192: 2,
  193: 2,
  194: 2,
  195: 2,
  196: 2,
  197: 2,
  198: 2,
  199: 2,
  200: 2,
  201: 2,
  202: 2,
  203: 2,
  204: 2,
  205: 2,
  206: 2,
  207: 2,
  208: 2,
  209: 2,
  210: 3,
  211: 3,
  212: 3,
  213: 3,
  214: 3,
  215: 3,
  216: 3,
  217: 3,
  218: 3,
  219: 3,
  220: 3,
  221: 3,
  222: 3,
  223: 3,
  224: 3,
  225: 3,
  226: 3,
  227: 3,
  228: 3,
  229: 3,
  230: 3,
  231: 3,
  232: 3,
  233: 3,
  234: 3,
  235: 3,
  236: 3,
  237: 3,
  238: 3,
  239: 3,
  240: 3,
  241: 3,
  242: 3,
  243: 3,
  244: 3,
  245: 3,
  246: 3,
  247: 3,
  248: 3,
  249: 3,
  250: 4,
  251: 4,
  252: 4,
  253: 4,
  254: 4,
  300: 1,
  301: 1,
  302: 1,
  303: 1,
  304: 1,
  305: 1,
  306: 1,
  307: 1,
  308: 1,
  309: 1,
  310: 1,
  311: 1,
  312: 1,
  313: 1,
  314: 1,
  315: 1,
  316: 1,
  317: 1,
  318: 1,
  319: 1,
  320: 2,
  321: 2,
  322: 2,
  323: 2,
  324: 2,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  329: 2,
  330: 2,
  331: 2,
  332: 2,
  333: 2,
  334: 2,
  335: 2,
  336: 2,
  337: 2,
  338: 2,
  339: 2,
  340: 2,
  341: 2,
  342: 2,
  343: 2,
  344: 2,
  345: 2,
  346: 2,
  347: 2,
  348: 2,
  349: 2,
  350: 3,
  351: 3,
  352: 3,
  353: 3,
  354: 3,
  355: 3,
  356: 3,
  357: 3,
  358: 3,
  359: 3,
  360: 3,
  361: 3,
  362: 3,
  363: 3,
  364: 3,
  365: 3,
  366: 3,
  367: 3,
  368: 3,
  369: 3,
  370: 3,
  371: 3,
  372: 3,
  373: 3,
  374: 3,
  375: 3,
  376: 3,
  377: 3,
  378: 3,
  379: 3,
  380: 4,
  440: 1,
  441: 1,
  442: 1,
  443: 1,
  444: 1,
  445: 1,
  446: 1,
  447: 1,
  448: 1,
  449: 1,
  450: 2
};
